export const coursesI18n = {
  en: {
    coursesEmpty: 'There aren\'t any subjects associated with this class.',
    writeObject: {
      create: 'Create write object',
      edit: 'Edit write object',
      eduacPaperTypes: 'Eduac Paper types',
      myPaperTypes: 'My paper types',
      none: 'None',
      notPapers: 'You don\'t have papers types',
      notSelected: 'The student will use the same problem file for the answer',
      addCover: 'Cover',
      addPaper: 'Paper',
      problemDisclamerSection: 'Use this section to upload a question. You can upload a PDF file.',
      responseDisclamer: 'Use this section to upload a PDF where the students can provide a response.',
      solutionDisclamer: 'Use this section to upload the correct answer to the question made on “Upload Question”. This will not be visible for students.',
      problemFile: 'problem',
      solutionFile: 'solution',
      problemTab: 'Problem',
      answerTab: 'Answer',
      solutionTab: 'Solution',
      responseTab: 'Response',
      downloadAll: 'Download all',
      notInfo: 'No information available',
      tabs: 'Tab view',
      splitVertical: 'Vertical view',
      splitHorizontal: 'Horizontal view',
      confirmEdit: 'There are students that have submitted their answers already. Are you sure you want to replace the Write Object?',
      saveAndExit: 'Save and exit',
      fileTab: 'File',
      courseMaterialTab: 'Subject Library',
      transparencyBoardsResetOnProblemOrResponseChanged: '⚠️ If you modify the problem or the response, the transparency boards will be reset',
    },
    courseMaterialObject: {
      createTitle: 'Create subject library object',
      editTitle: 'Edit subject library object'
    },
    objects: {
      confirmRemove: 'There are students that have submitted their answers already. Are you sure you want to delete this object?',
      confirmEdit: 'There are students that have submitted their answers already. Are you sure you want to replace this object?',
      confirmRotateEdit: 'Some students have started working on this task. If you rotate the original document, the existing annotations will be reset. Are you sure you want to continue?',
      transparencyBoardsResetOnRotate: '⚠️ Keep in mind that transparency boards will be reset if any page is rotated',
      transparencyBoardsResetOnFileChange: '⚠️ Keep in mind that transparency boards will be reset if the file is replaced',
      transparencyBoardsResetOnImagesReplaced: '⚠️ Keep in mind that transparency boards will be reset if images are replaced',
      transparencyBoardsResetOnSelectedPagesChanged: '⚠️ Transparency boards will be reset if selected pages are changed',
      dontAskeMe: 'Don\'t ask me about this for this day again',
      saveInDrafts: 'Save in drafts',
      answerHomework: 'Answer homework',
      dropFile: 'Drop the file here and create a file object type',
      createFile: 'Create file',
      createAudio: 'Create Audio',
      createMultimedia: 'Create multimedia file',
      editMultimedia: 'Edit multimedia file',
      createImage: 'Create image(s)',
      createText: 'Create text',
      blankTemplate: 'Add a blank page',
      paperTemplate: 'Duplicate page',
      dueDate: 'Due date',
      startDate: 'Start date',
      lastDateToSubmit: 'Last date to submit',
      dateForName: 'Use this date as name for this folder',
      alertStartDate: 'The folder you are moving: <b>{targetFolder}</b>, has a less start date than the destination folder: <b>{sourceFolder}</b>. What do you want to do?',
      saveAndMove: 'Save and move',
      useInheritDate: 'Use inherit date {inheritDate}',
      removeDate: 'Remove date {dateToRemove}',
      newNameForTheFolder: 'New name for the folder',
      copyWithDueDate: 'The object has a due date less than the folder\'s start date. Once copied, you will need to add a new due date in each one. Are you sure you want to continue?',
      moveObjectDueDate: 'The objects in this folder have a due date less than the folder\'s start date. Are you sure you want to save it and re-calculate the due date for the objects?',
      movingObjectDueDate: 'You are moving an object with due date manually <b>({dueDate})</b> to a folder with start date <b>({startDate})</b>. What do you want to do?',
      movingObjectAutoDueDate: 'You are moving an object with auto due date <b>({dueDate})</b> to a folder with start date <b>({startDate})</b>. The due date object will be calculated using the folder date like reference. Are you agree?',
      changeDueDate: 'Change due date',
      recalculateDueDate: 'Re-calculate due date',
      keepDueDate: 'Keep due date',
      homeworkExpired: 'The time for this assignment has expired',
      folderAfterOtherDates: 'One or some child objects has a due/start date less than this folder\'s start date. Once saved, you will need to add a new due/start date once. Are you sure you want to continue?',
      dateChangedManually: 'This date was selected manually',
      saveScanAsPdf: 'Save as pdf',
      openCamera: 'Open camera',
      closeCamera: 'Close camera',
      scanDocument: 'Scan document',
      uploadFile: 'Upload file',
      takeScan: 'Take picture',
      changeCamera: 'Change camera',
      downloading: 'Downloading',
      pageOf: 'page of',
    },
    materials: {
      courseMaterialsTitle: 'Library',
      courseMaterials: 'Subject Library',
      courseMaterialGallery: 'Subject Library Gallery',
      createCourseMaterialsTitle: 'Create Subject Library Content',
      editCourseMaterialsTitle: 'Edit subject library Content',
      deleteCourseMaterial: 'There is associated content as Subject Library in the Subject content. Are you sure you want to delete it?',
      library: 'Library',
      fileName: 'Name',
      subject: 'Subject',
      actionView: 'Action view',
      notCourseMaterials: 'You don\'t have anything added here yet',
      notCourseMaterialsOption: 'You don\'t have subject library availables',
      deleteCourseMaterialSection: 'All associated content will be lost, Are you sure you want to delete this folder?',
      errorDeleting: 'There was an error deleting this subject library. Try again please',
      offsetError: 'Only numbers between 0 and {offset} are allowed because it has {pages} pages. Please type a valid offset',
      disclamerNumber: 'Only Numbers',
      offset: 'Offset',
      splice: 'Section',
      continue: 'Page',
      fromStart: 'From {type} {start} to final page',
      fromStartToEnd: 'From {type} {start} to {final} {type} {end}',
      updateCourseMaterial: 'There are subject library objects associated with this document. What do you want to do with the existing subject library objects?',
      page: 'page',
      updatePageNumbers: 'Update the page numbers with the new offset',
      updateCourseMaterialObjects: 'Update the subject library object sections',
      final: 'final',
      errorDatesCMO: 'The numbers pages are wrong. The limit is {numOfPages}. Can you verify please?',
      selectPages: 'Select Pages',
      selectedPages: 'Selected Pages',
      pageSelectedEmpty: 'You don\'t have selected pages right now',
      errorFileCMO: 'There was an error getting the file, Try again later.',
      preparingFile: 'Your document is being generated. This process could take several minutes; please check back later.',
      waitingFile: 'Your document is being generated. Please wait.',
      presentationModeDisable: 'This element is not supported with the presentation mode.',
      rotateMessage: 'Rotating the file pages',
    },
    projects: {
      subjectProjects: 'Projects',
      disclamerName: 'Please write the full Name of your Project, max 60 car.',
      addFilesToProject: 'Update files for {project} project',
      addFilesToProjectDisclamer: 'You can add or remove files to the subject project.',
      noContent: 'There is no available content to add to the project.'
    },
    errors: {
      errorTitle: 'Oops!',
      errorResponseWriteObject: 'Sorry, there was an error trying creating the response. Try again',
      errorSavingObject: 'Sorry, there was an error trying to save the object. Try again',
      errorMaxFiles: 'Sorry, you can only add five images.',
      errorOpenWhiteboardObject: 'Sorry, there was an error trying opening the document',
      errorNotFoundOpenWhiteboardObject: 'Sorry, this document is not available, the information will be updated',
      errorAddWhiteboardPage: 'Sorry, there was an error trying adding a new page. Try again',
      errorSavingCourse: 'Sorry, there was an error trying to create the subject.',
      errorSavingCover: 'Sorry, there was an error trying to save the cover image.',
      errorLoadingCourse: 'Sorry, there was an error trying to load the subject.',
      editOtherFileExtensionAllowedError: 'This file type has other option to upload',
      editOtherFileExtensionNotAllowedError: 'This file type is not allowed',
      errorFormatNotSupported: 'Sorry, currently the format you are trying to upload is not supported',
      errorLoadingAnnotations: 'Sorry, there was an error trying to get the annotations. Try again',
      errorUpdatingAnnotations: 'Sorry, there was an error trying to update the annotations.',
      errorObtainingAnnotationsVersion: 'Sorry, there was an error trying to get the version from the annotations.',
      errorUploadingItemsTitle: 'Error uploading items!',
      codes: {
        DROPZONE001: 'File is empty. Please verify the selected file.',
        SF001: 'The file version is not supported in this object; please upload file in the "Other File" object.',
        SF002: 'The file version is not supported in this object; please upload file in the "File" object.',
        SM001: 'Invalid file version. Please verify the file version will be less than  version {epubVersion}.'
      }
    },
    info: {
      infoTitle: 'Info!',
      homeworkNotAvailable: 'This task has just been submitted by the student. Click Accept to open submitted task.',
      showAllTooltip: 'Enable to see the full subject content. Disable to see only the subject content for the previous {timeframe} days and the next {timeframe} days'
    },
    grade: {
      modalConfirmMsg: 'Do you want to set the grade of this assignment before submitting it?',
      modalActionWithGrade: 'Submit',
      modalActionWithoutGrade: 'Submit without grade',
      redo: 'Redo',
      grade: 'Grade',
      noGrade: 'No Grade',
      points: 'Points',
      selectGradeType: 'Please set a grade for each question.',
      gradeW: 'Grade',
      customScale: 'Custom Grading Scale',
      percentage: 'Percentage',
      letter: 'Letter',
      passFail: 'Pass/Fail',
      feedbackAlreadySubmitted: 'Feedback for this task has been submitted in another session.'
    },
    problem: 'Problem',
    answer: 'Answer',
    solution: 'Solution',
    typeObject: {
      createTypeObject: 'Create Type Object',
      editTypeObject: 'Edit Type Object',
      numberOfResponses: 'Number of responses',
      confirmEdit: 'There are students that have submitted their answers already. Are you sure you want to replace the Type Object?',
      alreadyAnswer: 'There are already answers, if you want you can go check them.',
      responses: 'Responses',
      notAnswer: 'This interactive activity doesn\'t have students to check now',
      reviewStudentResponses: 'Review Student Responses',
      taskExpired: 'The time to answer this assignment has expired',
      maxPoints: 'Maximum number of problems for response {response}'
    },
    controls: {
      showAllContent: 'Show all content'
    },
    deck: {
      addTitle: 'Add deck',
      editTitle: 'Edit deck',
      deckContent: 'Deck content',
      cartType: {
        double: 'Double sided',
        single: 'Single sided',
        both: 'Both'
      },
      disclamerName: 'Please write the full Name of your Deck, max 60 car.',
      addDecksDisclamer: 'We are creating amazing content for you. We work hard to give you the best experience as possible. Grow up  togheter and learn all you want to.',
      cardList: 'Current cards',
      addCard: 'Add card',
      frontSide: 'Front',
      backSide: 'Back',
      cardImage: 'Image',
      cardText: 'Text',
      cardCounter: 'This deck has {{cards}} cards',
      notSelectedCard: 'You don\'t have a selected card yet',
      confirmRemoveDeck: 'There may be Sub-Deck objects that will be deleted. Are you sure you want to remove the Deck Library?',
      confirmRemoveCard: 'There may be Sub-Deck objects containing cards that will be updated. Are you sure you want to remove the Card?',
      notSupported: 'Presentation mode is not supported for this object yet',
      bgImageTitle: 'Create background image',
      setCardName: 'Set Card Name',
      info: {
        fillCardTitle: 'Please fill up the card',
        cantSaveSingle: 'You must fill the front card.',
        cantSaveBoth: 'You must fill at least the front card.',
        cantSaveDouble: 'You must fill both sides of the card.',
        imageSizeExceededTitle: 'Image size exceeded',
        imageSizeExceeded: 'You can only upload images up to 5MB.',
        cardSaved: 'Card saved successfuly'
      },
      cardName: 'Card name',
      savingCards: 'Saving cards',
      emptySubDeck: 'This Sub Deck doesn\'t have selected cards',
    },
    subdeck: {
      random: 'Create this sub-deck using random cards',
      selectDeck: 'Select Deck',
      numberOfCards: 'Number of cards',
      randomView: 'Show the cards in a random order every time',
      disclamerName: 'Please write the full Name of your Sub Deck, max 60 car.',
      nCard: '#Card',
      outOf: 'out of',
      search: 'Search',
    },
    lesson: {
      finishHomework: 'Finish homework',
      openFeedback: 'Open feedback',
      addTitle: 'Add folder',
      addTitleTo: 'Add folder to',
      addbutton: 'Add folder',
      editTitle: 'Edit folder',
      errorFile: 'There was an error creating the file. Try again',
      disclamerName: 'Please write the full Name of your Lesson, max 60 car.',
      disclamerDescription: 'The description is a brief summary for users to quickly understand the contents of this section  (Max 200 characters)',
      insertUrl: 'Insert URL',
      grade: 'Grade',
      disclamerObjectDescription: 'Max 200 characters',
      disclamerObjectName: 'Max 60 characters',
      disclamerMaterialName: 'Max 70 characters',
      disclamerFileType: 'You can\'t upload files of this type.',
      disclamerMaxFiles: 'You can\'t upload any more files.',
      disclaimerVideoURLChanged: '⚠️ If you change the URL, the transparency boards for this video will be reset',
      disclamerBigFile: 'File is too big ({{filesize}} MB). Max filesize: {{maxFilesize}} MB.',
      dropZoneText: 'Drop files here to upload',
      dropZoneTextImage: 'You can upload images with the following extensions: .jpg, .png and .jpeg',
      dropZoneTextAudio: 'You can upload Audio with the following extensions: .mp3 and .wav',
      dropZoneTextMultimedia: 'You can upload Audio with the following extensions: .mp3 and .wav or Video with the following extension: .mp4. Max Size 200MB.',
      dropZoneRemove: 'Remove file',
      editVideoTitle: 'Edit Video',
      responseVideoTitle: 'Response Video',
      editFileTitle: 'Edit File',
      editFileDisclamer: 'You can upload files with the following extensions: .pdf, .docx, .doc, .xlsx, .xls, .epub, .pptx, .ppt, ',
      editFilePptHtml: 'html',
      editFileMaxSizeTitle: '. Max Size 200MB',
      editFilePptHtmlTitle: 'Click here for instructions to convert PowerPoint files (.ppt, .pptx) to HTML format so they can be viewed as a presentation',
      editFilePptHtmlDisclamer: 'These instructions can only be carried out by users on a Mac system because the Keynote application is required. <br> <ol style="margin-top:10px;"><li>1. Open the presentation with Keynote</li> <li>2. Click File</li> <li>3. Click Export and select HTML</li> <li>4. Click Next</li> <li>5. Click Save</li> <li>6. Write the name and select the folder</li> <li>7. Click Export</li> <li>8. Find the folder with the exported file, right click and select  Compress to save as a .zip file.</li> <li>9. Upload the .zip file generated through the Keynote app</li></ol> ',
      instructionsTitle: 'Instructions',
      homeworkResponse: 'You can upload files with the following extensions: .pdf, .docx, .doc, .xlsx, .xls. Max Size 200MB',
      editMaterialFileDisclamer: 'You can upload files with the following extensions: .pdf, .doc and .docx, Audio files: .mp3 and .wav and video files: .mp4. Max Size 200MB.' ,
      responseFileTitle: 'Response File',
      editLinkTitle:  'Edit URL',
      responseLinkTitle:  'Response URL',
      editTextTitle:  'Edit Text',
      responseTextTitle:  'Response Text',
      editImageTitle:  'Edit Image(s)',
      responseImageTitle:  'Response Image(s)',
      seeThePdf: 'See the PDF',
      goToUrl: 'Go to Url',
      addLessonDisclamer: 'We are creating amazing content for you. We work hard to give you the best experience as possible. Grow up  togheter and learn all you want to.',
      addSection: 'Add folder',
      courseEmpty: 'You don\'t have content in this section',
      projectsEmpty: 'You don\'t have projects yet',
      addContent: 'Add content',
      content: 'Content',
      isTeacherOnly: 'This section only can be viewed by the Teacher',
      onlyTeacher: 'Only teacher?',
      onlyVisibleTeacher: 'Only Visible for Teachers',
      visibleForAll: 'Visible for All',
      homeworkPending: 'Interactive activity pending',
      homeworkgraded: 'Interactive activity graded',
      addUrl: 'Add new URL',
      removeUrl: 'Remove URL',
      completedTasks: 'Completed Tasks',
      editOtherFileDisclamer: 'You can not upload files with the following extensions: {{otherExtensions}}. Max Size 200MB',
      downloadFile: 'Download File',
      onlyVisibleTeacherMessage: 'The objects related to this library will also change. Are  you sure?',
      onlyVisibleTeacherDontAskMessage: 'Do not ask again',
      editRotationPdfPages: 'Rotate pages',
      editRotationPdfPagesDisable: 'Rotate pages is loading',
      createLessonStructureByZip: 'Create structure by zip file',
      allowedFilesError: 'You can not upload files with the following extensions: {{otherExtensions}}',
    },
    createCourse: {
      createCourse: 'Create new Subject',
      updateCourse: 'Update the {courseName} subject',
      createCourseDisclamer: 'We are creating amazing content for you. We work hard to give you the best experience as possible. Grow up together and learn all you want to.',
      uploadCoverDisclamer: 'This will be the cover of the class for store.  Max 2mb weight',
      disclamerName: 'Please write the full Name of your Course, max 200 car.',
      dueDate: 'Default due date days',
      dueDateDisclamer: 'Due dates added to objects created in this subject will have their due dates set with this amount of days by default.',
      defaultLastDate: 'Default last date to submit',
      defaultLastDateDisclamer: 'Last date to submit added to objects created in this subject will have their due dates set with this amount of days by default.',
      subject: 'Subject',
      subjectDisclamer: 'It is the subject related to the class. (English, History, Math, etc)',
      descriptionDisclamer: 'The description is a brief summary for users to quickly understand the contents of this subject.',
      coverImage: 'Select a cover image',
      days: 'Days',
      coverRemoved: 'Cover image removed successfully',
      coverNoRemoved: 'There was a problem removing the cover image.',
      onToggleGrading: 'Disable custom grading scale',
      offToggleGrading: 'Enable custom grading scale',
      hasGrading: 'Grading Scale',
      disclamerToggleGrading: 'This option will enable a custom grading scale for this subject',
      confirmGrading: 'This subject may have graded tasks, are you sure you want to enable/disable?',
      selectTags: 'Select Tag',
      subjectDays: 'Subject Days',
      duration: 'Duration',
      subjectDaysDisclamer: 'The number of days the subject is going to last.',
      durationDisclamer: 'The duration of each subject day.',
      suggestedLessonDuration: 'Suggested lesson duration',
      minutes: 'Minutes',
      startLessonVarianceLabel: '+/-',
      endLessonVarianceLabel: 'min allowed lesson variance.',
      lessonVarianceDisclamer: 'Value in minutes to indicate the time range allowed to add a lesson to a calendar block.',
      fitFirstAvailable: 'Fit the lessons on the first available day',
      disclamerFitFirstAvailable: 'This option allows lessons to be adjusted to the next available school day, regardless of their lesson duration and the available time'
    },
    linkObject: {
      open: 'Open Link',
      notSupported: 'Link Objects are not currently supported in this device'
    },
    otherFilesObject: {
      notSupported: 'Other Files Objects are not currently supported in this device'
    },
    textEditor: {
      createTableTitle: 'Create Table',
      tableRestriction: 'Values must be between 1 and 30',
      restrictions: {
        lessThanZero: 'This field must be greater than 0',
        greaterThanThirty: 'This field must be less than or equal to 30'
      },
      menu: {
        hading: 'Heading',
        fontSize: 'Font Size',
        fontFamily: 'Font Family',
        fontColor: 'Font Color',
        backgroundColor: 'Background Color',
        undo: 'Undo',
        redo: 'Redo',
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strike: 'Strike',
        pow: 'Pow',
        sub: 'Sub Index',
        clean: 'Clean Format',
        alignLeft: 'Align Left',
        alignCenter: 'Align Center',
        alignRight: 'Align Right',
        justify: 'Justify',
        increaseIndent: 'Increase Indent',
        decreaseIndent: 'Decrease Indent',
        changeTextDirection: 'Change Text Direction',
        blockQuote: 'Block Quote',
        bulletList: 'Bullet List',
        numberedList: 'Numbered List',
        image: 'Image',
        video: 'Video',
        link: 'Link',
        table: 'Table',
        codeBlock: 'Code Block',
        addFormula: 'Add Formula',
      }
    },
    subjectBuilder:{
      subjectBuilder: 'Subject Builder',
      subjectCalendar: 'Subject Calendar',
      rules: 'Rules',
      preview: 'Preview',
      selectSchoolCalendar: 'Select school calendar period',
      run: 'Run',
      noDayContent: 'There is no content for the day selected.',
      schoolCalendar: 'School Calendar',
      schoolCalendarInfo: 'You can select other School Calendar period',
      chooseCalendar: 'Choose School Calendar',
      subjectTeachingDays: 'Subject teaching days',
      enableRule: 'Enable Rule',
      disableRule: 'Disable Rule',
      standardDay: 'Standard Day',
      dayOff: 'Day Off',
      funDay: 'Fun Day',
      fun: 'Fun',
      lesson: 'Lesson',
      contentLesson: 'Lesson',
      fillerLesson: 'Filler lesson',
      funLesson: 'Fun lesson',
      filler: 'Filler',
      holiday: 'Holiday',
      rulesDisclamer: 'You can update or create new rules.',
      calendar: 'Calendar',
      lessons: 'Lessons',
      editor: 'Subject Editor',
      calendar_legacy: '2. Calendar',
      subjectDescription: 'Subject Information',
      subjectDescription_legacy: '1. Subject Information',
      subjectLessons_legacy: '3. Lessons',
      confirmDone: 'Are you sure you want to confirm all changes and build the subject?',
      confirmDoneProjects: 'You have projects in this template with lessons from fillers or fun. Those lessons aren\'t part of this new subject. Are you sure you want to build the subject without lessons?',
      continue: 'Continue',
      buildingDisclamer: 'You can continue using the app while the system is building the subject. You won\'t lose any changes if you leave this page.',
      creatingSubjectLabel: 'Creating subject',
      createdSubjectLabel: 'Subject created',
      notStartedLabel: 'Loading',
      errorSubjectLabel: 'Subject not created',
      goToSubject: 'Go to subject',
      addRule: 'Add rule',
      moveRuleQuestion: 'What do you want to do?',
      undo: 'Undo',
      build: 'Build',
      buildSubject: 'Build Subject',
      lessonStart : 'Start of: {lesson}',
      lessonEnd : 'Ends: {lesson}',
      lessonEndLabel : 'End of: {lesson}',
      lessonSchoolDay : 'This day continues with \'{lesson}\'',
      lessonNonSchoolDay : 'This is not a school day for \'{lesson}\'',
      lessonNonTimeDay : 'There is no available time on this day for \'{lesson}\'',
      movements: {
        future: {
          optionLabelA: 'Move {from} to {to}',
          optionSublabelA: '(And shift the following lessons moving forward)',
          optionLabelB: 'Replace {to} with {from}',
          optionSublabelB: '(Don\'t use {to} at this time. It will still be available in Additional Content)',
          optionSublabelBToNotContent: '(Don\'t use {to} at this time)',
          optionLabelC: 'Swap {from} with'
        },
        back: {
          optionLabelA: 'Move {from} to {to}',
          optionSublabelA: '(And shift the other Lessons back)',
          optionLabelB: 'Replace {to} with {from}',
          optionSublabelB: '(And make {dateFrom} as day off. {to} will still be available in Additional Content)',
          optionSublabelBToNotContent: '(And make {dateFrom} as day off)',
          optionLabelC: 'Swap {from} with'
        }
      },
      errors: {
        errorNoFoundCalendar: 'This organization doesn\'t have School Calendars available. It must exist an active or a future School Calendar.',
        errorNoFoundCalendarTitle: 'No School Calendar available',
        errorGetCalendar: 'There was a problem trying to get a calendar.',
        emptyTemplate: 'Empty template',
        emptyTemplateBody: 'This template does not contain any lessons',
        movementForbiddenTitle: 'Action forbidden',
        errorMovingLesson: 'You can\'t make movements between lessons and fun lessons.',
        errorMovingToDayOff: 'You can\'t move lessons to days off.',
        errorMovingFunToAny: 'You can only move fun lessons to fun days.',
        errorBuildingCourse: 'There was a problem trying to build the subject. Please try again.',
        errorMovingLessonWithOutStartDate: 'You can\'t make movements to date where not start lessons.',
      },
      info: {
        overflowLessonsTitle: 'Lessons Overflow',
        overflowLessons: 'The current action is moving some of the content lessons to the aditional content folder. You can accept or undo this change.',
      },
      rulesContainer: {
        rule: 'Rule',
        startLessonInfo: 'Pick from which lesson # the subject will start on',
        endLessonInfo: 'Pick in which lesson # the subject should end',
        tagInfo: 'Place objects tagged as',
        dayInfo: 'on',
        startOn: 'Start on',
        endOn: 'End on',
        run: 'Run',
        on: 'on',
        startLessonOption: 'Start on a custom lesson # for this Subject',
        startLessonLabel: 'From lesson {lessonFrom} to lesson {lessonTo}',
        tagDayOption: 'Place objects with a tag on a specific day of the week',
        tags: 'Tags',
        teachingDay: 'Teaching day',
        warningTagRepeated: 'You can have one rule per tag. Only the rule marked as active',
        warningStartLessonRepeated: 'You can have one rule for the lesson\'s limits. Only the rule marked as active',
        willBeApplied: 'will be applied.',
        activeRule: 'Active rule',
        tagObjectInfo: 'This objects was moved here because of the rule:  Place objects with {tag} tag on {weekday}',
        previousLesson: 'Force previous lessons to objects tagged as {tag} to be taught before them.'
      }
    },
    eduacComponents: {
      errorSaving: 'Error saving component changes',
      errorSavingTitle: 'Error',
      createTitle: 'Create Component',
      editTitle: 'Edit Component',
      deleteQuestion: 'Are you sure you want to delete this component?',
      customizeComponents: 'Customize Components',
      customize: 'Customize',
      customizeSub: 'You can make changes around the components or create a new one.',
      customizeInput: 'Name of component',
      warningLibraryTitle: 'This is the component of the library selected'
    }
  },
  es: {
    coursesEmpty: 'No hay materias asociadas a esta clase',
    writeObject: {
      create: 'Crear anotación',
      edit: 'Editar anotación',
      eduacPaperTypes: 'Tipos de papel de Eduac',
      myPaperTypes: 'Mis tipos de papel',
      none: 'Sin tipo de papel',
      notPapers: 'No hay tipos de papel',
      notSelected: 'El estudiante usará el mismo archivo del problema para la repuesta',
      addCover: 'Portada',
      addPaper: 'Archivo',
      problemDisclamerSection: 'Usa esta sección para subir la pregunta. Puedes subir archivos PDF.',
      responseDisclamer: 'Use esta sección para subir un PDF donde los estudiantes puedan responder',
      solutionDisclamer: 'Usa esta sección para subir la respuesta correcta a la pregunta hecha en "Problema". Esto no lo veran los estudiantes.',
      problemFile: 'problema',
      solutionFile: 'solución',
      problemTab: 'Problema',
      answerTab: 'Respuesta',
      solutionTab: 'Solución',
      responseTab: 'Respuesta',
      downloadAll: 'Descargar todo',
      notInfo: 'Información no disponible',
      tabs: 'Vista en pestañas',
      splitVertical: 'Vista vertical',
      splitHorizontal: 'Vista horizontal',
      confirmEdit: 'Hay estudiantes que ya han respondido esta tarea. ¿Seguro que quieres reemplazar esta anotación?',
      saveAndExit: 'Guardar y salir',
      fileTab: 'Archivo',
      courseMaterialTab: 'Material de curso',
      transparencyBoardsResetOnProblemOrResponseChanged: '⚠️ Los boards de transparencia se reestablecerán si modificas el problema o la respuesta',
    },
    courseMaterialObject: {
      createTitle: 'Crear objeto librería del curso',
      editTitle: 'Editar objeto librería del curso'
    },
    objects: {
      confirmRemove: 'Hay estudiantes que ya han respondido esta tarea. ¿Seguro que quieres eliminar este objeto?',
      confirmEdit: 'Hay estudiantes que ya han respondido esta tarea. ¿Seguro que quieres reemplazar este objeto?',
      confirmRotateEdit: 'Hay estudiantes que están trabajando en esta tarea. Si rotas el documento original, las anotaciones van a ser reestablecidas. ¿Seguro que quieres continuar?',
      transparencyBoardsResetOnRotate: '⚠️ Ten en cuenta que los tableros de transparencia se reestablecerán si se rota alguna página',
      transparencyBoardsResetOnFileChange: '⚠️ Ten en cuenta que los tableros de transparencia se reestablecerán si el archivo se reemplaza',
      transparencyBoardsResetOnImagesReplaced: '⚠️ Ten en cuenta que los tableros de transparencia se reestablecerán si modificas alguna imagen',
      transparencyBoardsResetOnSelectedPagesChanged: '⚠️ Los boards de transparencia se reestablecerán si modificas las páginas seleccionadas',
      dontAskeMe: 'No preguntar de nuevo por este día',
      saveInDrafts: 'Guardar en borradores',
      answerHomework: 'Responder tarea',
      dropFile: 'Suelta el archivo aquí y crea un tipo de objeto de archivo',
      createFile: 'Crear archivo',
      createAudio: 'Crear Audio',
      createMultimedia: 'Crear archivo multimedia',
      editMultimedia: 'Editar archivo multimedia',
      createImage: 'Crear imagen(es)',
      createText: 'Crear texto',
      blankTemplate: 'Agregar una página en blanco',
      paperTemplate: 'Duplicar página',
      dueDate: 'Fecha límite',
      startDate: 'Fecha de inicio',
      lastDateToSubmit: 'Última fecha para enviar',
      dateForName: 'Usar la fecha como nombre de la carpeta',
      alertStartDate: 'La carpeta <b>{targetFolder}</b> que estas moviendo tiene una fecha de inicio menor a la carpeta de destino <b>{sourceFolder}</b>. ¿Qué quieren hacer?',
      saveAndMove: 'Guardar y mover',
      useInheritDate: 'Usar fecha heredada {inheritDate}',
      removeDate: 'Remover fecha {dateToRemove}',
      newNameForTheFolder: 'Nuevo nombre para la carpeta',
      copyWithDueDate: 'El objeto tiene una fecha de vencimiento menor que la fecha de inicio de la carpeta. Una vez copiado, deberá agregar una nueva fecha de vencimiento. Estás seguro de que quieres continuar?',
      moveObjectDueDate: 'Los objetos en esta carpeta tienen fecha de expiración menor que la fecha de inicio de la carpeta ¿Estas seguro que deses guardar y recalcular la fecha de expiración de los objetos?',
      movingObjectDueDate: 'Estas moviendo un objeto con fecha de vencimiento manual <b>({dueDate})</b> al folder con fecha de inicio <b>({startDate})</b>. ¿Qué quieres hacer?',
      movingObjectAutoDueDate: 'Estas moviendo un objeto con fecha de vencimiento automática <b>({dueDate})</b> al folder con fecha de inicio <b>({startDate})</b>. La fecha de vencimiento del objeto será calculada usando la fecha del folder como referencia ¿Estás de acuerdo?',
      changeDueDate: 'Cambiar fecha de expiración',
      recalculateDueDate: 'Recalcular fecha de expiración',
      keepDueDate: 'Mantener fecha de expiración',
      homeworkExpired: 'El tiempo para esta tarea ha expirado',
      folderAfterOtherDates: 'Uno o algunos objetos secundarios tienen una fecha de vencimiento/inicio menor que la fecha de inicio de esta carpeta. Una vez guardado, deberá agregar una nueva fecha de vencimiento/inicio en cada una. Estás seguro de que quieres continuar?',
      dateChangedManually: 'Fecha cambiada manualmente',
      saveScanAsPdf: 'Guardar como pdf',
      openCamera: 'Abrir cámara',
      closeCamera: 'Cerrar cámara',
      scanDocument: 'Escanear documento',
      uploadFile: 'Subir archivo',
      takeScan: 'Tomar foto',
      changeCamera: 'Cambiar cámara',
      downloading: 'Descargando',
      pageOf: 'Página de',
    },
    materials: {
      courseMaterialsTitle: 'Librería',
      courseMaterials: 'Librería del curso',
      courseMaterialGallery: 'Galeria de Librerías del curso',
      createCourseMaterialsTitle: 'Crear contenido en la librería del curso',
      editCourseMaterialsTitle: 'Editar contenido en la librería del curso',
      uploadCourseMaterialsTitle: 'Cargar libraría al curso',
      updateCourseMaterialsTitle: 'Actualizar contenido en la Librería del curso',
      deleteCourseMaterial: 'Hay contenido asociado a esta librería del curso. ¿Está seguro que quiere eliminarlo?',
      library: 'Librería',
      fileName: 'Nombre',
      subject: 'Tema',
      actionView: 'Ver librería',
      notCourseMaterials: 'Aún no tienes librerías en este curso.',
      notCourseMaterialsOption: 'No tienes librerías del curso disponibles',
      deleteCourseMaterialSection: 'Todo el contenido asociado a esta sección se perderá ¿Está seguro que desea eliminar esta carpeta?',
      errorDeleting: 'Hubo un error al borrar esta librería del curso. Por favor intente de nuevo',
      offsetError: 'Sólo se permiten números entre 0 y {offset} , por que el documento tiene {pages} páginas. Por favor ingrese un desfase válido',
      disclamerNumber: 'Sólo Números',
      offset: 'Desfase',
      splice: 'Sección',
      continue: 'Página',
      fromStart: 'Desde {type} {start} hasta la página final',
      fromStartToEnd: 'Desde {type} {start} hasta {type} {end} {final}',
      updateCourseMaterial: 'Hay objetos tipo subject library asociados con este documento. Qué desea hacer con estos objetos?',
      page: 'página',
      updatePageNumbers: 'Actualizar las páginas con el nuevo desfase',
      updateCourseMaterialObjects: 'Actualizar los objetos tipo subject library',
      final: 'final',
      errorDatesCMO: 'Los números de página están mal. El limite es {numOfPages}. ¿Puede verificar por favor?',
      selectPages: 'Selecciona las Páginas',
      selectedPages: 'Páginas seleccionadas',
      pageSelectedEmpty: 'No tienes paginas seleccionadas en este momento.',
      errorFileCMO: 'Hubo un error al tratar de obtener las librerías del Curso, Intente de nuevo más tarde',
      preparingFile: 'Estamos generando su archivo, este proceso puede tardar algunos minutos; por favor consulte mas tarde.',
      waitingFile: 'Estamos generando su archivo. Por favor espere.',
      presentationModeDisable: 'Este elemento no es soportado en modo presentación.',
      rotateMessage: 'Rotando las hojas del documento',
    },
    projects: {
      subjectProjects: 'Proyectos',
      disclamerName: 'Por favor escribe el nombre completo de tu proyecto, máximo 60 caracteres.',
      addFilesToProject: 'Actualizar archivos para el proyecto {project}',
      addFilesToProjectDisclamer: 'Puede agregar o eliminar archivos del proyecto de curso.',
      noContent: 'No hay contenido disponible para agregar al proyecto.'
    },
    errors: {
      errorTitle: 'Oops!',
      errorResponseWriteObject: 'Hubo un error intentando crear la respuesta. Intenta de nuevo',
      errorSavingObject: 'Hubo un error intentando guardar el objeto. Intenta de nuevo',
      errorMaxFiles: 'Lo sentimos, puede agregar máximo cinco imágenes.',
      errorOpenWhiteboardObject: 'Hubo un error intentando abrir el documento',
      errorNotFoundOpenWhiteboardObject: 'Este documento no se encuentra disponible, la información será actualizada',
      errorAddWhiteboardPage: 'Hubo un error intentando agregar una nueva página. Intenta de nuevo',
      errorSavingCourse: 'Hubo un error intentando crear el curso.',
      errorSavingCover: 'Hubo un error intentando guardar la imagen de portada.',
      errorLoadingCourse: 'Hubo un error intentando cargar la información del curso.',
      editOtherFileExtensionAllowedError: 'Este tipo de archivo ya tiene una opción para subir',
      editOtherFileExtensionNotAllowedError: 'Este tipo de archivo no es permitido',
      errorFormatNotSupported: 'Lo sentimos, actualmente el formato que está intentando cargar no es compatible',
      errorLoadingAnnotations: 'Lo sentimos, hubo un error al intentar obtener las anotaciones. Intenta de nuevo',
      errorUpdatingAnnotations: 'Lo sentimos, hubo un error al intentar actualizar las anotaciones.',
      errorObtainingAnnotationsVersion: 'Lo sentimos, hubo un error al intentar obtener la versión de las anotaciones.',
      errorUploadingItemsTitle: 'Error cargando los objetos!',
      codes: {
        DROPZONE001: 'El archivo esta vacio. Por favor verifique el archivo seleccionado.',
        SF001: 'La versión del archivo no es soportada en este objeto; por favor cargue el archivo en el objeto "Otros Archivos".',
        SF002: 'La versión del archivo no es soportada en este objeto; por favor cargue el archivo en el objeto "Archivo".',
        SM001: 'Versión del archivo invalida. Por favor verifique que la versión del archivo sea menor a {epubVersion}.'
      }
    },
    info: {
      infoTitle: 'Info!',
      homeworkNotAvailable: 'El alumno acaba de enviar esta tarea. Clic en aceptar para abrir la tarea enviada.',
      showAllTooltip: 'Active esta opción para ver el contenido completo del curso. Desactivela solo para ver solo el contenido del curso de los {timeframe} días anteriores y los próximos {timeframe} días',
    },
    grade: {
      modalConfirmMsg: '¿Deseas colocar la calificación a esta tarea antes de enviarla?',
      modalActionWithGrade: 'Enviar',
      modalActionWithoutGrade: 'Enviar sin calificación',
      redo: 'Rehacer',
      grade: 'Calificar',
      noGrade: 'No calificar',
      points: 'Puntos',
      selectGradeType: 'Seleccione una nota para cada pregunta.',
      gradeW: 'Nota',
      customScale: 'Escala personalizada',
      percentage: 'Porcentaje',
      letter: 'Letras',
      passFail: 'Aprobado/Reprobado',
      feedbackAlreadySubmitted: 'Ya se envió retroalimentación para esta tarea en otra sesión.'
    },
    problem: 'Problema',
    answer: 'Respuesta',
    solution: 'Solución',
    typeObject: {
      createTypeObject: 'Crear tipado',
      editTypeObject: 'Editar tipado',
      numberOfResponses: 'Número de respuestas',
      confirmEdit: 'Hay estudiantes que ya han respondido esta tarea. ¿Seguro que quieres reemplazar esta anotación?',
      responses: 'Respuestas',
      alreadyAnswer: 'Ya hay respuestas, puede ir a revisarlas si desea.',
      notAnswer: 'Esta actividad interactiva no tiene respuesta de estudiante para verificar ahora.',
      reviewStudentResponses: 'Revisar respuestas',
      taskExpired: 'El tiempo para responder esta tarea ha expirado',
      maxPoints: 'Máximo número de problemas para la respuesta {response}'
    },
    controls: {
      showAllContent: 'Mostrar todo el contenido'
    },
    deck: {
      addTitle: 'Adicionar baraja',
      editTitle: 'Editar bajara',
      disclamerName: 'Por favor escribe el nombre completo de tu baraja, máximo 60 caracteres.',
      addDecksDisclamer: 'Estamos creando contenido increíble para ti. Trabajamos duro para brindarle la mejor experiencia posible. Crecer juntos y aprender todo lo que quieras.',
      deckContent: 'Contenido de la baraja',
      cartType: {
        double: 'Doble cara',
        single: 'Una cara',
        both: 'Ambas'
      },
      cardList: 'Tarjetas actuales',
      addCard: 'Adicionar tarjeta',
      frontSide: 'Frente',
      backSide: 'Espalda',
      cardImage: 'Imagen',
      cardText: 'Texto',
      cardCounter: 'Esta baraja contiene {{cards}} tarjetas',
      notSelectedCard: 'Aun no tiene una tarjeta seleccionada',
      confirmRemoveDeck: 'Pueden existir sub barajas que serán borrados. Está seguro que quiere borrar la Baraja?',
      confirmRemoveCard: 'Pueden existir sub barajas con cartas que seran retiradas. Está seguro que quiere borrar la tarjeta?',
      notSupported: 'Modo presentación aún no es soportado para este objeto',
      bgImageTitle: 'Crear imagen de fondo',
      setCardName: 'Establecer el nombre de la tarjeta',
      info: {
        fillCardTitle: 'Por favor llene la tarjeta',
        cantSaveSingle: 'Debe llenar la tarjeta frontal.',
        cantSaveBoth: 'Debe llenar al menos la tarjeta frontal.',
        cantSaveDouble: 'Debe llenar los dos lados de la tarjeta.',
        imageSizeExceededTitle: 'Tamaño de la imagen excedido',
        imageSizeExceeded: 'Solo puede agregar imágenes de hasta 5MB.',
        cardSaved: 'Tarjeta guardada exitosamente'
      },
      cardName: 'Nombre de la tarjeta',
      savingCards: 'Guardando tarjetas',
      emptySubDeck: 'No hay cartas en este sub deck',
    },
    subdeck: {
      random: 'Crear este sub-deck usando tarjetas aleatorias',
      selectDeck: 'Seleccione una baraja',
      numberOfCards: 'Numero de tarjetas',
      randomView: 'Mostrar las tarjetas en un orden aleatorio cada vez',
      disclamerName: 'Por favor escribe el nombre completo de tu sub baraja, máximo 60 caracteres.',
      nCard: '#Tarjeta',
      outOf: 'de',
      search: 'Buscar',
    },
    lesson: {
      finishHomework: 'Finalizar tarea',
      openFeedback: 'Abrir retroalimentación',
      addTitle: 'Añadir carpeta',
      addTitleTo: 'Añadir carpeta a',
      addbutton: 'Añadir carpeta',
      editTitle: 'Editar carpeta',
      errorFile: 'Hubo un error creando el archivo. Intente de nuevo.',
      disclamerName: 'Por favor escribe el nombre completo de tu sección, máximo 60 caracteres.',
      disclamerDescription: 'La descripción es un breve resumen para que los usuarios comprendan rápidamente el contenido de esta sección',
      insertUrl: 'Insertar URL',
      grade: 'Calificación',
      disclamerObjectDescription: 'Máx 200 car',
      disclamerObjectName: 'Máx 60 car',
      disclamerMaterialName: 'Máx 70 car',
      disclamerFileType: 'No puedes subir archivos de este tipo.',
      disclamerMaxFiles: 'No puedes subir más archivos.',
      disclaimerVideoURLChanged: '⚠️ Si cambias la URL, los tableros de transparencia de este video se reestablecerán',
      disclamerBigFile: 'El archivo es demasiado grande ({{filesize}}MB). Máximo tamaño permitido: {{maxFilesize}}MB.',
      dropZoneText: 'Arrastra aquí los archivos para subirlos',
      dropZoneTextImage: 'Puedes cargar imágenes con las siguientes extensiones: .jpg, .png and .jpeg',
      dropZoneTextAudio: 'Puedes cargar Audio con las siguientes extensiones: .mp3 y .wav',
      dropZoneTextMultimedia: 'Puedes cargar Audio con las siguientes extensiones: .mp3 y .wav ó Video con la siguiente extensión: .mp4. Tamaño máximo 200MB.',
      dropZoneRemove: 'Remover archivo',
      editVideoTitle: 'Editar Video',
      responseVideoTitle: 'Video de Respuesta',
      editFileTitle: 'Editar Archivo',
      editFileDisclamer: 'Puedes cargar las siguientes extensiones: .pdf, .docx, .doc, .xlsx, .xls, .epub, .pptx, .ppt, ',
      editFilePptHtml: 'html',
      editFileMaxSizeTitle: '. Tamaño máximo 200MB',
      editFilePptHtmlTitle: 'Click aqui para ver las instrucciones para convertir un archivo PowerPoint (.ppt, .pptx) a formato HTML para visualizarlo como una presentación',
      editFilePptHtmlDisclamer: 'Estas instrucciones pueden ser realizadas solo por usuario en sistema operativo Mac, ya que es requerida la aplicación Keynote. <br> <ol style="margin-top:10px;"><li>1. Abra la presentación con Keynote </li> <li>2. Click en Archivo </li> <li>3. Click en Exportar y seleccione HTML</li> <li>4. Click en Siguiente </li> <li>5. Click en Guardar</li> <li>6. Escriba el nombre y seleccione el directorio</li> <li>7. Click en Exportar</li> <li>8. Encuentre el directorio donde se encuentra el archivo, click derecho y seleccionar Comprimir como archivo .zip</li> <li>9. Suba el archivo .zip generado desde la aplicación Keynote</li></ol> ',
      instructionsTitle: 'Instrucciones',
      homeworkResponse: 'Puedes cargar las siguientes extensiones: .pdf, .docx, .doc, .xlsx., .xls. Tamaño máximo 200MB',
      editMaterialFileDisclamer: 'Puedes cargar Archivos con las siguientes extensiones: .pdf, .doc y .docx, Archivos de audio: .mp3 y .wav y archivos de video: .mp4. Tamaño máximo 200MB.',
      responseFileTitle: 'Archivo de Respuesta',
      editLinkTitle:  'Editar URL',
      responseLinkTitle:  'URL de Respuesta',
      editTextTitle:  'Editar Texto',
      responseTextTitle:  'Texto de Respuesta',
      editImageTitle:  'Editar Imagen(es)',
      responseImageTitle:  'Imagen(es) de Respuesta',
      seeThePdf: 'Ver el PDF',
      goToUrl: 'Ir al enlace',
      addLessonDisclamer: 'Estamos creando contenido increíble para ti. Trabajamos duro para brindarle la mejor experiencia posible. Crecer juntos y aprender todo lo que quieras.',
      addSection: 'Añadir carpeta',
      courseEmpty: 'Aún no tienes contenido en esta sección',
      addContent: 'Añadir contenido',
      projectsEmpty: 'Aún no tienes proyectos en este curso',
      content: 'Contenido',
      isTeacherOnly: 'Esta sección solo podrá ser vista por el profesor',
      onlyTeacher: '¿Solo el profesor?',
      onlyVisibleTeacher: 'Solo visible para profesores',
      visibleForAll: 'Visible por todos',
      homeworkPending: 'Tarea pendiente',
      homeworkgraded: 'Tarea calificada',
      addUrl: 'Añadir URL',
      removeUrl: 'Remover URL',
      completedTasks: 'Tareas completadas',
      editOtherFileDisclamer: 'No puedes cargar las siguientes extensiones: {{otherExtensions}}. Tamaño máximo 200MB',
      downloadFile: 'Descargar Archivo',
      onlyVisibleTeacherMessage: 'Los objetos relacionados con esta librería(s) deben cambiar también. Esta usted seguro?',
      onlyVisibleTeacherDontAskMessage: 'No volver a preguntar',
      editRotationPdfPages: 'Rotar paginas',
      editRotationPdfPagesDisable: 'Rotar paginas esta cargando',
      createLessonStructureByZip: 'Crear estructure desde un archivo zip',
      allowedFilesError: 'No puedes cargar las siguientes extensiones: {{otherExtensions}}.',
    },
    createCourse: {
      createCourse: 'Crear curso nuevo',
      updateCourse: 'Actualizar el curso {courseName}',
      createCourseDisclamer: 'Estamos creando contenido increíble para ti. Trabajamos arduamente para brindarle la mejor experiencia posible. Crecer juntos y aprender todo lo que quieras.',
      uploadCoverDisclamer: 'Será la portada de la clase para tienda.  Max 2mb de peso',
      disclamerName: 'Escriba el nombre completo de su curso, máximo 200 car.',
      dueDate: 'Días de fecha de vencimiento predeterminado',
      dueDateDisclamer: 'Las fechas de vencimiento agregadas a los objetos creados en este curso tendrán sus fechas de vencimiento establecidas con esta cantidad de días de forma predeterminada.',
      defaultLastDate: 'Ultimo día de fecha de vencimiento predeterminado',
      defaultLastDateDisclamer: 'Las fechas de vencimiento agregadas a los objetos creados en este curso tendrán sus fechas de vencimiento establecidas con esta cantidad de días de forma predeterminada.',
      subject: 'Materia',
      subjectDisclamer: 'Es la materia relacionada con la clase. (Inglés, historia, matemáticas, etc.)',
      descriptionDisclamer: 'La descripción es un breve resumen para que los usuarios comprendan rápidamente el contenido de este curso.',
      coverImage: 'Seleccione una imagen de portada',
      days: 'Días',
      coverRemoved: 'La portada del curso se eliminó correctamente.',
      coverNoRemoved: 'Hubo un problema removiendo la portada del curso.',
      onToggleGrading: 'Habilitar escala de calificación personalizada',
      offToggleGrading: 'Deshabilitar escala de calificación personalizada',
      hasGrading: 'Escala de Calificación',
      disclamerToggleGrading: 'Esta opción permite habilitar o deshabilitar la calificación para este curso.',
      confirmGrading: 'Es posible que este curso tenga tareas calificadas, ¿está seguro de que desea habilitar/deshabilitar la calificación para este curso?',
      selectTags: 'Seleccionar Etiqueta',
      subjectDays: 'Días del Curso',
      duration: 'Duración',
      subjectDaysDisclamer: 'El número de días que durará el curso',
      durationDisclamer: 'La duración de cada día del curso.',
      suggestedLessonDuration: 'Duración de lección sugerida',
      minutes: 'Minutos',
      startLessonVarianceLabel: '+/-',
      endLessonVarianceLabel: 'minimo variacion de lección permitida allowed lesson variance.',
      lessonVarianceDisclamer: 'Valor en minutos para indicar la varacion en tiempo permitida para agregar una lecciona a un bloque del calendario.',
      fitFirstAvailable: 'Ajustar las lecciones en el primer dia disponible',
      disclamerFitFirstAvailable: 'Esta opcion permite ajustar las lecciones al primer dia disponible, sin importar la duracion de la leccion y el tiempo disponible',
    },
    linkObject: {
      open: 'Abrir enlace',
      notSupported: 'Los enlaces no están soportados actualmente en este dispositivo'
    },
    otherFilesObject: {
      notSupported: 'La descarga de archivos no está soportada actualmente en este dispositivo'
    },
    textEditor: {
      createTableTitle: 'Crear Tabla',
      tableRestriction: 'Los valores deben estar entre 1 y 30',
      restrictions: {
        lessThanZero: 'Este campo debe ser mayor a 0',
        greaterThanThirty: 'Este campo debe ser menor o igual a 30'
      },
      menu: {
        hading: 'Encabezado',
        fontSize: 'Tamaño de la Fuente',
        fontFamily: 'Tipo de Fuente',
        fontColor: 'Color de la Fuente',
        backgroundColor: 'Color del Fondo',
        undo: 'Deshacer',
        redo: 'Rehacer',
        bold: 'Negrita',
        italic: 'Cursiva',
        underline: 'Subrayar',
        strike: 'Tachar',
        pow: 'Potenciar',
        sub: 'Sub Índice',
        clean: 'Limpiar Formato',
        alignLeft: 'Alineado Izquierdo',
        alignCenter: 'Alineado Central',
        alignRight: 'Alineado Derecho',
        justify: 'Justificar',
        increaseIndent: 'Incrementar Indentación',
        decreaseIndent: 'Decrementar Indentación',
        changeTextDirection: 'Cambiar Dirección del Texto',
        blockQuote: 'Cita en Bloque',
        bulletList: 'Lista de viñetas',
        numberedList: 'Lista Enumerada',
        image: 'Imagen',
        video: 'Video',
        link: 'Enlace',
        table: 'Tabla',
        codeBlock: 'Bloque de Código',
        addFormula: 'Fórmula',
      }
    },
    subjectBuilder:{
      subjectBuilder: 'Constructor de curso',
      subjectCalendar: 'Calendario de curso',
      rules: 'Reglas',
      preview: 'Previsualización',
      selectSchoolCalendar: 'Seleccione el período del calendario escolar',
      run: 'Ejecutar',
      noDayContent: 'No hay contenido para el día seleccionado.',
      schoolCalendar: 'Calendario Escolar',
      schoolCalendarInfo: 'Puede seleccionar otro calendario escolar.',
      chooseCalendar: 'Seleccionar Calendario Escolar',
      subjectTeachingDays: 'Días hábiles del curso',
      enableRule: 'Habilitar Regla',
      disableRule: 'Deshabilitar Regla',
      standardDay: 'Día hábil',
      dayOff: 'Día libre',
      funDay: 'Día divertido',
      fun: 'Diversión',
      contentLesson: 'Lección',
      fillerLesson: 'Lección de relleno',
      funLesson: 'Lección de diversión',
      lesson: 'Lección',
      filler: 'Relleno',
      holiday: 'Festivo',
      rulesDisclamer: 'Puede actualizar o crear nuevas reglas.',
      calendar: '2. Calendario',
      lessons: 'Lecciones',
      editor: 'Editor del curso',
      subjectDescription: 'Información del curso',
      subjectLessons: '3. Lecciones',
      confirmDone: '¿Está seguro de confirmar todos los cambios y construir la materia?',
      confirmDoneProjects: 'Tienes proyectos con lecciones de Fillers o Fun que non parte de esta materia. ¿Está seguro de construir la materia sin esos lessons?',
      continue: 'Continuar',
      buildingDisclamer: 'Puedes continuar utilizando el app mientras el sistema construye la materia. No perderás tus cambios si abandonas está página.',
      creatingSubjectLabel: 'Creando materia',
      createdSubjectLabel: 'Materia creada',
      notStartedLabel: 'Cargando',
      errorSubjectLabel: 'Materia no creada',
      goToSubject: 'Ir a la materia',
      addRule: 'Agregar regla',
      moveRuleQuestion: 'Qué desea hacer?',
      undo: 'Deshacer',
      build: 'Construir',
      buildSubject: 'Construir Curso',
      lessonStart : 'Inicio de: {lesson}',
      lessonEnd : 'Finaliza: {lesson}',
      lessonEndLabel : 'Fin de: {lesson}',
      lessonSchoolDay : 'Este día se continua con \'{lesson}\'',
      lessonNonSchoolDay : 'Este no es un día hábil para \'{lesson}\'',
      lessonNonTimeDay : 'Este día la leccion \'{lesson}\' no tiene tiempo asignado',
      movements: {
        future: {
          optionLabelA: 'Mover {from} a {to}',
          optionSublabelA: '(Y mover las siguientes lecciones en el futuro)',
          optionLabelB: 'Reemplazar {to} con {from}',
          optionSublabelB: '(No usar {to} esta vez. Aún estará disponible como contenido adicional)',
          optionSublabelBToNotContent: '(No usar {to} esta vez)',
          optionLabelC: 'Intercambiar {from} con '
        },
        back: {
          optionLabelA: 'Mover {from} a {to}',
          optionSublabelA: '(Y mover las otras lecciones hacia atrás)',
          optionLabelB: 'Reemplazar {to} con {from}',
          optionSublabelB: '(Marcar {dateFrom} como día libre. {to} aún estará disponible como contenido adicional)',
          optionSublabelBToNotContent: '(Marcar {dateFrom} como día libre)',
          optionLabelC: 'Intercambiar {from} con'
        }
      },
      errors: {
        errorGetCalendar: 'Hubo un problema para encontrar un calendario.',
        errorNoFoundCalendarTitle: 'Esta organización no tiene Calendarios Escolares disponibles, debe existir un Calendario activo o futuro.',
        errorNoFoundCalendar: 'No hay Calendarios Escolares disponibles',
        emptyTemplate: 'Plantilla vacía',
        emptyTemplateBody: 'Esta plantilla no contiene lecciones.',
        movementForbiddenTitle: 'Acción prohibida',
        errorMovingLesson: 'No puede hacer movimientos entre lecciones y lecciones divertidas.',
        errorMovingToDayOff: 'No puede mover lecciones a días libres.',
        errorMovingFunToAny: 'Solo puede mover lecciones divertidas a días divertidos.',
        errorBuildingCourse: 'Hubo un problema para construir el curso. Por favor intente nuevamente.',
        errorMovingLessonWithOutStartDate: 'No puede mover lecciones a días donde no hay lessons iniciando.',
      },
      info: {
        overflowLessonsTitle: 'Desbordamiento de lecciones',
        overflowLessons: 'La acción actual, mueve algunas de las lecciones de contenido al folder de contenido adicional. Puede aceptar o deshacer este cambio.',
      },
      rulesContainer: {
        rule: 'Regla',
        startLessonInfo: 'Señala la lección para el primer día del curso.',
        endLessonInfo: 'Señala la lección para el último día del curso.',
        tagInfo: 'Ubicar objetos etiquetados como',
        dayInfo: 'los días',
        startOn: 'Iniciar en',
        endOn: 'Finalizar en',
        run: 'Ejecutar',
        on: 'los',
        startLessonOption: 'Iniciar en una lección específica para esta materia',
        startLessonLabel: 'Desde la lección {lessonFrom} hasta la lección {lessonTo}',
        tagDayOption: 'Ubicar objetos con etiqueta en un día específico de la semana',
        tags: 'Etiquetas',
        teachingDay: 'Día hábil',
        warningTagRepeated: 'Solo puede agregar una regla para cada etiqueta. Solo la regla marcada como activa',
        warningStartLessonRepeated: 'Solo puede agregar una regla para los límites de lecciónes. Solo la regla marcada como activa',
        willBeApplied: 'será aplicada.',
        activeRule: 'Regla activa',
        tagObjectInfo: 'Este objeto fue movido aquí por la regla: Ubicar objetos con etiqueta {tag} los días {weekday}.',
        previousLesson: 'Forzar previas lecciones a objetos etiquetados como {tag} a ser enseñados antes de la lección.'
      }
    },
    eduacComponents: {
      errorSaving: 'Error guardando cambios del componente',
      errorSavingTitle: 'Error',
      createTitle: 'Crear Componente',
      editTitle: 'Editar Componente',
      deleteQuestion: 'Esta seguro de querer eliminar este componente?',
      customizeComponents: 'Customizar Componentes',
      customize: 'Customizar',
      customizeSub: 'Puedes hacerle cambios a componentes o crear nuevos.',
      customizeInput: 'Nombre del componente',
      warningLibraryTitle: 'Este es el componente de la libraria seleccionada'
    }
  }
};
